/**
 * @author Kajabi, LLC <info@kajabi.com>
 * @license MIT
 */
import { useEffect, useCallback } from "react";
import { useApi } from "@backstage/core";
import { useAsyncFn } from "react-use";
import { useEntity } from "@backstage/plugin-catalog-react";
import { handleError } from "./utils";
import { confluenceApiRef } from "@internal/plugin-confluence-api";
import { useProjectEntity } from "./useProjectEntity";

export const useSearch = () => {
  const api = useApi(confluenceApiRef);

  const entity = useEntity();
  const { query, limit, userId } = useProjectEntity(entity?.entity);

  const getSearch = useCallback(async () => {
    try {
      const response = await api.search({ query, limit, userId });
      return response.data.data;
    } catch (err: any) {
      return handleError(err);
    }
  }, [api, query, limit, userId]);

  const [state, fetchSearch] = useAsyncFn(async () => {
    return await getSearch();
  }, []);

  useEffect(() => {
    fetchSearch();
  }, [fetchSearch]);

  return {
    loading: state.loading,
    error: state.error,
    results: state?.value?.results,
    baseUrl: state?.value?._links?.base,
    fetchSearch,
  };
};
